export function reducer(PRELOAD) {
    const initial = {
        active: PRELOAD.ui_settings?.zth_dashboard_active ?? false,
    };
    return (state = initial, actions) => {
        switch (actions.type) {
            case 'ZTH_DASHBOARD_ACTIVATE':
                return { ...state, active: true };
            case 'ZTH_DASHBOARD_DEACTIVATE':
                return { ...state, active: false };
            default:
                return state;
        }
    };
}
